"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomComponents = exports.OptionItem = exports.formatTitle = exports.Icon = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_select_1 = require("react-select");
var style_1 = require("../../../style");
var Text_1 = __importDefault(require("../../Text"));
var layout_1 = require("../../layout");
var data_display_1 = require("../../data-display");
var styles_1 = require("./styles");
var variables_1 = require("../../../style/variables");
var SelectSingleValue_1 = require("./_base/SelectSingleValue");
var SelectMenuItem_1 = __importDefault(require("./_base/SelectMenuItem"));
var SelectChip_1 = __importDefault(require("./_base/SelectChip"));
var InputContainer_1 = __importDefault(require("../_base/InputContainer"));
var BaseSelectContainer = react_select_1.components.SelectContainer;
var Icon = function (_a) {
    var showDot = _a.showDot, showUserIcon = _a.showUserIcon, imageUrl = _a.imageUrl, disabled = _a.disabled;
    if (showDot) {
        return react_1.jsx(data_display_1.Dot, { size: "md", color: "Success" });
    }
    if (showUserIcon) {
        return (react_1.jsx(data_display_1.Avatar, { name: "", size: "xs", placeholderType: "icon", css: { opacity: disabled ? 0.6 : undefined } }));
    }
    if (imageUrl) {
        return (react_1.jsx(data_display_1.Avatar, { name: "", src: imageUrl, size: "xs", placeholderType: "icon", css: { opacity: disabled ? 0.6 : undefined }, wrapperClassName: "icon" }));
    }
    return null;
};
exports.Icon = Icon;
var formatTitle = function (label, subLabel) { return subLabel ? label + "\n" + subLabel + "\n" : label; };
exports.formatTitle = formatTitle;
var OptionItem = function (_a) {
    var label = _a.label, subLabel = _a.subLabel, imageUrl = _a.imageUrl, showDot = _a.showDot, showUserIcon = _a.showUserIcon, disabled = _a.isDisabled, isMulti = _a.isMulti, isLabel = _a.isLabel, size = _a.size;
    return (react_1.jsx(layout_1.Flex, { alignItems: "center", gap: 8, css: { overflow: 'hidden' }, title: exports.formatTitle(label, subLabel) },
        !isMulti && (react_1.jsx(exports.Icon, { showDot: showDot, showUserIcon: showUserIcon, imageUrl: imageUrl, disabled: disabled })),
        react_1.jsx("span", { css: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } },
            react_1.jsx(Text_1.default.Body, __assign({ color: disabled ? style_1.DesignSystemThemeColor.Gray.LIGHT_2 : style_1.DesignSystemThemeColor.Gray.DARK_4 }, (isLabel ? { css: styles_1.styles.label(size) } : { size: 'md' })), label),
            subLabel ? (react_1.jsx(Text_1.default.Body, __assign({}, (isLabel ? { css: styles_1.styles.subLabel(size) } : { size: 'md' }), { color: disabled ? style_1.DesignSystemThemeColor.Gray.LIGHT_2 : style_1.DesignSystemThemeColor.Gray.DEFAULT }), subLabel)) : null)));
};
exports.OptionItem = OptionItem;
var createCustomComponents = function (_a) {
    var readOnly = _a.readOnly, size = _a.size, selectType = _a.selectType, icon = _a.icon, borderless = _a.borderless, error = _a.error, className = _a.className, optionType = _a.optionType;
    return ({
        IndicatorSeparator: function () { return null; },
        LoadingIndicator: function () { return null; },
        ClearIndicator: function () { return null; },
        SelectContainer: function (props) { return (react_1.jsx(BaseSelectContainer, __assign({}, props, { isDisabled: readOnly || props.isDisabled, innerProps: __assign(__assign({}, props.innerProps), { style: __assign(__assign({}, props.innerProps.style), { border: 'none' }), 'data-6si-name': 'select' }) }))); },
        Input: function (props) { return (react_1.jsx(react_select_1.components.Input, __assign({}, props, { "data-6si-name": "select--input" }))); },
        Menu: function (props) { return (react_1.jsx(react_select_1.components.Menu, __assign({}, props, { innerProps: __assign(__assign({}, props.innerProps), { 'data-6si-name': 'select--menu' }) }))); },
        Placeholder: function (_a) {
            var children = _a.children, props = __rest(_a, ["children"]);
            var textColor = props.isDisabled
                ? variables_1.ComponentColor.Form.Text.DISABLED
                : variables_1.ComponentColor.Form.Text.PLACEHOLDER;
            return (react_1.jsx(react_select_1.components.Placeholder, __assign({}, props),
                react_1.jsx(Text_1.default.Body, { color: "var(" + textColor + ")", size: size === 'sm' ? 'sm' : 'default' }, children)));
        },
        SingleValue: function (props) { return (react_1.jsx(react_select_1.components.SingleValue, __assign({}, props),
            react_1.jsx(SelectSingleValue_1.SingleValueText, { selectType: selectType, disabled: props.isDisabled || props.selectProps.menuIsOpen, label: props.data.label, subLabel: props.data.subLabel, imageUrl: props.data.imageUrl, icon: props.data.icon || icon, size: size }))); },
        Option: function (props) { return (react_1.jsx(react_select_1.components.Option, __assign({}, props, { innerProps: __assign(__assign({}, props.innerProps), { 'data-6si-name': 'select--option', 'data-6si-id': props.data.value }) }),
            react_1.jsx(SelectMenuItem_1.default, { tooltipText: props.data.tooltipText, label: props.data.label, subLabel: props.data.subLabel, imageUrl: props.data.imageUrl, selected: props.isSelected, focused: props.isFocused, disabled: props.data.isDisabled, icon: props.data.icon || icon, selectType: selectType, title: props.data.title, optionType: optionType }))); },
        Control: function (_a) {
            var children = _a.children, props = __rest(_a, ["children"]);
            var selectedOption = props.getValue()[0];
            var multiPadding = size === 'sm' ? '2.5px 3px' : '5px 7px';
            return (react_1.jsx(react_select_1.components.Control, __assign({}, props, { innerProps: __assign(__assign({}, props.innerProps), { 'data-6si-name': 'select--control' }) }),
                react_1.jsx(InputContainer_1.default, { element: "label", css: {
                        display: 'flex',
                        cursor: 'pointer',
                        padding: props.isMulti ? multiPadding : undefined,
                        borderColor: borderless ? 'transparent' : undefined,
                        maxHeight: props.selectProps.menuIsOpen ? '340px' : '100px',
                        overflow: 'overlay',
                    }, size: size, disabled: props.isDisabled, readOnly: readOnly, error: error, className: className },
                    !props.isMulti ? (react_1.jsx(SelectSingleValue_1.SingleValueLeading, { selectType: selectType, disabled: props.isDisabled, label: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label, subLabel: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.subLabel, imageUrl: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.imageUrl, icon: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.icon) || icon, size: "sm" })) : null,
                    children)));
        },
        MultiValue: function (props) { return (react_1.jsx(SelectChip_1.default, __assign({}, props, { selectType: selectType, size: size, readOnly: readOnly, icon: icon }))); },
        GroupHeading: function (_a) {
            var children = _a.children, props = __rest(_a, ["children"]);
            return (react_1.jsx(react_select_1.components.GroupHeading, __assign({}, props),
                react_1.jsx(layout_1.Flex, { alignItems: "center", css: { height: 45, padding: '0 12px' } },
                    react_1.jsx(Text_1.default, { color: "var(" + (props.data.isDisabled ? variables_1.TextColor.DISABLED : variables_1.TextColor.DEFAULT) + ")", size: style_1.pxToRem(12, 16), weight: 600, transform: "uppercase" }, children))));
        },
    });
};
exports.createCustomComponents = createCustomComponents;
